<template>
  <div :class="['switch_box', { active: value }]" @click="switchChange">
    <!--      {{value ? '开' : '关'}}-->
    <div :class="['switch_child', { child_active: value }]">
      {{ value ? "开" : "关" }}
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    value: {
      type: [Number, Boolean],
      default: 0,
    },
    object: {
      type: Object,
      default: () => { },
    }
  },
  data () {
    return {
      switchVal: 0
    };
  },
  mounted () {
    this.switchVal = this.value;
  },
  methods: {
    switchChange: function () {
      if (this.$listeners.confirmFn) {
        let fn = this.$listeners.confirmFn(this.switchVal ? 0 : 1, this.object);
        fn && fn.then(() => {
          this.switchValueUpdate();
        }).catch(() => {
          console.log("error");
        });
      } else {
        this.switchValueUpdate();
      }
    },
    switchValueUpdate: function () {
      this.switchVal = this.switchVal ? 0 : 1;
      this.$emit("input", this.switchVal);
    }
  }
};
</script>

<style lang="less" scoped>
.switch_box {
  width: 34px;
  background-color: #e4e4e4;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  &.active {
    background-color: #1abc9c;
  }
  .switch_child {
    background-color: #a4a4a4;
    width: 18px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    border-radius: 4px;
    transition: all 0.5s;
    transform: rotateX(0);
    &.child_active {
      background-color: rgb(52, 73, 94);
      transform: translateX(16px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/switch-button/index.vue